import UrlPattern from 'url-pattern';

// ToDO: Deprecate this function
export const extractPathFromProxy = path => {
  return path;
};

export const getUrlParams = (url, match) => {
  /* 
    ref:
      1. https://www.npmjs.com/package/url-pattern
      2. https://github.com/snd/url-pattern
      3. https://bundlephobia.com/result?p=url-pattern@1.0.3
  */
  const pattern = new UrlPattern(match);
  return pattern.match(url);
};
